import gql from 'graphql-tag';

export default gql`
  mutation ($id: MongoID!, $displayName: String) {
    updateVideoLibrary(_id: $id, record: { displayName: $displayName }) {
      recordId
      record {
        _id
        filename
        displayName
        url
        ext
        size
        duration
        mtime
      }
    }
  }
`;
